"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBarObserver = void 0;
const EventType_1 = require("./EventType");
var StatusBarColors;
(function (StatusBarColors) {
    StatusBarColors["Red"] = "rgb(218,0,0)";
    StatusBarColors["Green"] = "rgb(0,218,0)";
})(StatusBarColors || (StatusBarColors = {}));
class StatusBarObserver {
    constructor(statusBarItem, showLogCommand) {
        this.statusBarItem = statusBarItem;
        this.showLogCommand = showLogCommand;
    }
    post(event) {
        switch (event.type) {
            case EventType_1.EventType.DotnetAcquisitionStart:
                this.setAndShowStatusBar('$(cloud-download) Downloading .NET...', this.showLogCommand, '', 'Downloading .NET...');
                break;
            case EventType_1.EventType.DotnetAcquisitionCompleted:
            case EventType_1.EventType.DotnetInstallExpectedAbort:
                this.resetAndHideStatusBar();
                break;
            case EventType_1.EventType.DotnetAcquisitionError:
                this.setAndShowStatusBar('$(alert) Error acquiring .NET!', this.showLogCommand, StatusBarColors.Red, 'Error acquiring .NET');
                break;
        }
    }
    dispose() {
        // Nothing to dispose
    }
    setAndShowStatusBar(text, command, color, tooltip) {
        this.statusBarItem.text = text;
        this.statusBarItem.command = command;
        this.statusBarItem.color = color;
        this.statusBarItem.tooltip = tooltip;
        this.statusBarItem.show();
    }
    resetAndHideStatusBar() {
        this.statusBarItem.text = '';
        this.statusBarItem.command = undefined;
        this.statusBarItem.color = undefined;
        this.statusBarItem.tooltip = undefined;
        this.statusBarItem.hide();
    }
}
exports.StatusBarObserver = StatusBarObserver;
//# sourceMappingURL=StatusBarObserver.js.map